var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.groups),function(group,index){return _c('output-group-summary',{key:index,attrs:{"group":group,"destination":_vm.destination,"is-ended":_vm.isEnded}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }